import axios from 'axios'
import { useRouter,useRoute } from "vue-router";
import { getToken, clear } from '../utils/token.js'
import { encryptBase64, encryptWithAes, generateAesKey, decryptWithAes, decryptBase64 } from '../utils/crypto';
import { encrypt, decrypt } from '../utils/jsencrypt';
import Cookies from 'js-cookie'
import { MessagePlugin } from 'tdesign-vue-next';
import { handleUnauthorizedRedirect } from '../utils/auth-redirect.js'

// 创建一个 axios 实例'
let token = localStorage.getItem('token')
const router = useRouter()
const route = useRoute()

export const globalHeaders = () => {
  token = localStorage.getItem('token')
  return {
    Authorization: token,
    clientid: import.meta.env.VITE_APP_CLIENT_ID
  };
};
const encryptHeader = 'encrypt-key';
const service = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL, // 所有的请求地址前缀部分
  timeout: 120000, // 请求超时时间毫秒
  withCredentials: false, // 异步请求携带cookie
  headers: {
    // 设置后端需要的传参类型
    'Content-Type': 'application/json',
    Authorization: token,
    'X-Requested-With': 'XMLHttpRequest',
    'clientid': import.meta.env.VITE_APP_CLIENT_ID,
    'isEncrypt': true
  }
})

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    if (!config.headers.Authorization) {
      // if (config?.url === '/auth/sms/login') {
      //   token = localStorage.getItem('token') || null
      //   if (!token || token === 'null' || token === 'undefined') {
      //     token = getToken()
      //     if (token) {
      //       localStorage.setItem('token', token)
      //     }
      //   }
      // } else if (config?.url === '/api/tenant/v1') {
      //   token = sessionStorage.getItem('l_token') || localStorage.getItem('token')
      // } else {
      //   token = getToken()
      //   if (token) {
      //     localStorage.setItem('token', token)
      //   }
      // }
      if (config?.url === '/auth/login') {
        config.headers.Authorization = ''
        localStorage.removeItem('token')
      } else {
        token = null
        token = localStorage.getItem('token') || null
          if (!token || token === 'null' || token === 'undefined') {
            localStorage.setItem('token', token)
          }
        config.headers.Authorization = token
      }
    } else {
      if (config?.url === '/auth/login') {
        config.headers.Authorization = ''
        localStorage.removeItem('token')
      } else {
        config.headers.Authorization = ''
        config.headers.Authorization = localStorage.getItem('token')
      }
    }
    // 是否需要加密
    const isEncrypt = config.headers?.isEncrypt === 'true';
    if (import.meta.env.VITE_APP_ENCRYPT === 'true') {
      // 当开启参数加密
      if (isEncrypt && (config.method === 'post' || config.method === 'put')) {
        // 生成一个 AES 密钥
        const aesKey = generateAesKey();
        config.headers[encryptHeader] = encrypt(encryptBase64(aesKey));
        config.data = typeof config.data === 'object' ? encryptWithAes(JSON.stringify(config.data), aesKey) : encryptWithAes(config.data, aesKey);
      }
    }
    return config
  },
  function (error) {
    // 对请求错误做些什么
    // console.log(error)
    return Promise.reject(error)
  }
)

/**
 * 获取 url 里的参数
 * @param url
 * @param param
 * @returns {null|string}
 */
function getQueryStringParam(url, param) {
  // 获取 '?' 后面的查询字符串部分
  const queryString = url.split('?')[1] || '';
  // 分割查询字符串为键值对数组
  const params = queryString.split('&');

  for (let i = 0; i < params.length; i++) {
    const pair = params[i].split('=');
    // 对查询字符串进行解码，以处理编码的字符
    if (decodeURIComponent(pair[0]) === param) {
      return decodeURIComponent(pair[1] || '');
    }
  }

  return null; // 如果没有找到参数，则返回null
}

// 401 统一跳转逻辑已抽到 src/utils/auth-redirect.js 中

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    if (response.data.code === 401) {
      handleUnauthorizedRedirect()
      localStorage.removeItem('token')
      return response.data
    }
    // console.log(response)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // dataAxios 是 axios 返回数据中的 data
    if (import.meta.env.VITE_APP_ENCRYPT === 'true') {
      // 加密后的 AES 秘钥
      const keyStr = response.headers[encryptHeader];
      // 加密
      if (keyStr != null && keyStr != '') {
        const data = response.data;
        // 请求体 AES 解密
        const base64Str = decrypt(keyStr);
        // base64 解码 得到请求头的 AES 秘钥
        const aesKey = decryptBase64(base64Str.toString());
        // aesKey 解码 data
        const decryptData = decryptWithAes(data, aesKey);
        // 将结果 (得到的是 JSON 字符串) 转为 JSON
        response.data = JSON.parse(decryptData);
      }
    }
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    const code = dataAxios.reset
    return dataAxios
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if (error?.response?.status === 401) {
      // TODO 后端区别 401 与 403
      // 如果有 token 和 uid，尝试免密登录
      if (route.query.talentId || route.query.screenId || route.query.recruitmentId) {
        localStorage.setItem('screenLinkQueryTalentId', route.query.talentId)
        localStorage.setItem('screenLinkQueryScreenId', route.query.screenId)
        localStorage.setItem('screenLinkQueryRecruitmentId', route.query.recruitmentId)
      }
      handleUnauthorizedRedirect()
      return Promise.resolve({data:[]})
    }
    if (error.response) {
      return Promise.reject(error)
    } else {
      error.message = '当前网络未连接，请检查当前设备的网络设置';
      return Promise.reject(error);
    }
  }
)

export default service
